import { render, staticRenderFns } from "./IQOverlay.vue?vue&type=template&id=68241abb"
import script from "./IQOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./IQOverlay.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQOverlay.vue?vue&type=style&index=0&id=68241abb&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports